import React from "react";
import axios from "axios";
import { notifications } from '@mantine/notifications';
import { Group, Text, Loader, Box, Checkbox, useMantineTheme, Textarea } from '@mantine/core';
import { IconPencil } from '@tabler/icons-react';

import { useLoginContext } from "../../context/loginContext";
import { BE_API_TWO, utils } from "../../utils/globalVariables";
import { safeValue } from "../../utils/globalFunctions";
import { canAccessModifyModulQC } from "../../utils/accessing";

import ModalResponse from "../general/ModalResponse";
import ModalTakeAction from "../general/ModalTakeAction";

const BarangFormCekDetilQC = ({ stateData, stateDataProject, fnOnChange }) => {

    const theme = useMantineTheme();
    const mountedRef = React.useRef(true);
    const { loginContext, handleSetLoginContext } = useLoginContext();

    const notificationId = React.useRef({
        errorSubmitDataCheck: 'BarangFormCekDetilQC-1',
        errorSubmitDataKeterangan: 'BarangFormCekDetilQC-2',
    })

    const [data, setData] = React.useState({
        submitLoadingCheck: false,

        keteranganModal: false,
        keteranganValue: '',
        keteranganId: '',
        keteranganLoadingSubmit: false,

        modalResponse: {
            show: false,
            type: utils.modalResponse.warning,
            hideOnClickOutSide: false,
            content: ''
        }
    });

    React.useEffect(() => {
        return () => {
            mountedRef.current = false;
        }
    }, [])

    const submitDataCheck = (id, cek) => {
        setData(d => ({
            ...d,
            submitLoadingCheck: true,
        }))

        const formDT = new FormData();
        const formDTHeader = { 'Content-Type': 'application/json' }

        formDT.append('json_token', loginContext.syswebapp);
        formDT.append('project_id', stateDataProject.projectId);
        formDT.append('project_process', stateDataProject.projectProcess);
        formDT.append('project_is_cancel', stateDataProject.projectIsCancel);
        formDT.append('project_form_cek_detil_id', id);
        formDT.append('project_form_cek_detil_cek_qc', Number(cek));

        axios({
            method: 'post',
            url: BE_API_TWO + '/edit_project_barang_form_cek_detil_qc_cek',
            data: formDT,
            headers: formDTHeader,
        }).then((response) => {
            if (!mountedRef.current) return null;

            setData(d => ({ ...d, submitLoadingCheck: false }));

            if (response.data.flag_status === 'isset') {
                fnOnChange(response.data.data);
            }

            if (response.data.flag_status === 'error') {
                notifications.show({
                    id: notificationId.current.errorSubmitDataCheck,
                    title: utils.notification.warning.caption,
                    message: response.data.pesan,
                    color: utils.notification.warning.color,
                    icon: utils.notification.warning.icon,
                    withBorder: true,
                    autoClose: true,
                })
            }

            if (response.data.flag_status === 'no-data') {
                setData(d => ({
                    ...d,
                    modalResponse: {
                        ...d.modalResponse,
                        type: utils.modalResponse.warning,
                        hideOnClickOutSide: true,
                        content: 'Data tidak ditemukan.',
                        show: true
                    }
                }))
            }

            if (response.data.flag_status === 'invalid-json-token') {
                handleSetLoginContext(null);
            }

            if (response.data.flag_status === 'user-inactive') {
                handleSetLoginContext(null);
            }
        }).catch(error => {
            if (!mountedRef.current) return null;

            setData(d => ({
                ...d,
                submitLoadingCheck: false
            }))

            notifications.show({
                id: notificationId.current.errorSubmitDataCheck,
                title: utils.notification.warning.caption,
                message: error.message,
                color: utils.notification.warning.color,
                icon: utils.notification.warning.icon,
                withBorder: true,
                autoClose: true,
            })
        })
    }

    const submitDataKeterangan = () => {
        setData(d => ({
            ...d,
            keteranganLoadingSubmit: true,
        }))

        const formDT = new FormData();
        const formDTHeader = { 'Content-Type': 'application/json' }

        formDT.append('json_token', loginContext.syswebapp);
        formDT.append('project_id', stateDataProject.projectId);
        formDT.append('project_process', stateDataProject.projectProcess);
        formDT.append('project_is_cancel', stateDataProject.projectIsCancel);
        formDT.append('project_form_cek_detil_id', data.keteranganId);
        formDT.append('project_form_cek_detil_cek_keterangan', data.keteranganValue);

        axios({
            method: 'post',
            url: BE_API_TWO + '/edit_project_barang_form_cek_detil_qc_keterangan',
            data: formDT,
            headers: formDTHeader,
        }).then((response) => {
            if (!mountedRef.current) return null;

            setData(d => ({ ...d, keteranganLoadingSubmit: false }));

            if (response.data.flag_status === 'isset') {
                setData(d => ({ ...d, keteranganValue: '', keteranganId: '', keteranganModal: false }))
                fnOnChange(response.data.data);
            }

            if (response.data.flag_status === 'error') {
                notifications.show({
                    id: notificationId.current.errorSubmitDataKeterangan,
                    title: utils.notification.warning.caption,
                    message: response.data.pesan,
                    color: utils.notification.warning.color,
                    icon: utils.notification.warning.icon,
                    withBorder: true,
                    autoClose: true,
                })
            }

            if (response.data.flag_status === 'no-data') {
                setData(d => ({
                    ...d,
                    modalResponse: {
                        ...d.modalResponse,
                        type: utils.modalResponse.warning,
                        hideOnClickOutSide: true,
                        content: 'Data tidak ditemukan.',
                        show: true
                    }
                }))
            }

            if (response.data.flag_status === 'invalid-json-token') {
                handleSetLoginContext(null);
            }

            if (response.data.flag_status === 'user-inactive') {
                handleSetLoginContext(null);
            }
        }).catch(error => {
            if (!mountedRef.current) return null;

            setData(d => ({
                ...d,
                keteranganLoadingSubmit: false
            }))

            notifications.show({
                id: notificationId.current.errorSubmitDataKeterangan,
                title: utils.notification.warning.caption,
                message: error.message,
                color: utils.notification.warning.color,
                icon: utils.notification.warning.icon,
                withBorder: true,
                autoClose: true,
            })
        })
    }

    const canModify = utils.projectProcess.qc.value;

    return (
        <React.Fragment>
            <Group
                position="apart"
                noWrap
                align='flex-start'
            >
                <Box>
                    <Checkbox
                        checked={Boolean(Number(stateData.is_check_qc))}
                        onChange={
                            ((canModify === stateDataProject.projectProcess) && (canAccessModifyModulQC({ stateObject: { subLevel: loginContext } }))) ?
                                (event) => submitDataCheck(stateData.barang_form_cek_detil_id, event.target.checked)
                                :
                                () => { }
                        }
                        color={((canModify === stateDataProject.projectProcess) && (canAccessModifyModulQC({ stateObject: { subLevel: loginContext } }))) ? 'blue' : 'gray'}
                        size='xs'
                        label={
                            <Box>
                                <Group spacing='.5rem'>
                                    <Checkbox
                                        checked={Boolean(Number(stateData.is_check_nota))}
                                        onChange={(e) => { }}
                                        color="gray"
                                        readOnly
                                        size='xs'
                                        label={
                                            <Group align="center" spacing={8}>
                                                {stateData.barang_form_cek_detil_name}
                                            </Group>
                                        }
                                    />

                                    {data.submitLoadingCheck && <Loader size="1rem" />}
                                </Group>

                                {stateData.keterangan_nota &&
                                    <Text size='sm' mt='.25rem' ml='1.75rem' color="dimmed">
                                        {stateData.keterangan_nota}
                                    </Text>
                                }
                            </Box>
                        }
                    />

                    {stateData.keterangan_qc &&
                        <Text size='sm' mt='xs' ml='1.75rem'>
                            {stateData.keterangan_qc}
                        </Text>
                    }
                </Box>

                {((canModify === stateDataProject.projectProcess) && (canAccessModifyModulQC({ stateObject: { subLevel: loginContext } }))) &&
                    <Box>
                        <IconPencil
                            size={18}
                            style={{ cursor: 'pointer' }}
                            color={theme.colors.blue[6]}

                            onClick={() => setData(d => ({
                                ...d,
                                keteranganId: stateData.barang_form_cek_detil_id,
                                keteranganValue: safeValue(stateData.keterangan_qc, ''),
                                keteranganModal: true,
                            }))}
                        />
                    </Box>
                }
            </Group>

            <ModalResponse
                stateShow={data.modalResponse.show}
                fnHide={() => setData(d => ({
                    ...d,
                    modalResponse: {
                        ...d.modalResponse,
                        show: false
                    }
                }))}

                stateHideOnClickOutSide={data.modalResponse.hideOnClickOutSide}
                stateType={data.modalResponse.type}
                stateContent={data.modalResponse.content}
            />

            <ModalTakeAction
                stateShow={data.keteranganModal}
                fnHide={() => setData(d => ({ ...d, keteranganModal: false }))}

                stateHideOnClickOutSide={true}
                stateTitle={String('Keterangan').toUpperCase()}
                stateOverlayZIndex={201}

                stateButtonClosePx='md'

                stateButtonActionCaption='Submit'
                stateButtonActionPx='xs'
                stateButtonActionColor="red"
                stateButtonActionLoading={data.keteranganLoadingSubmit}
                fnButtonAction={submitDataKeterangan}
            >
                <Textarea
                    value={data.keteranganValue}
                    minRows={3}
                    maxRows={4}
                    onChange={(e) =>
                        setData(d => ({
                            ...d,
                            keteranganValue: e.target.value
                        }))
                    }

                    label=''
                    placeholder='Keterangan'
                    error=''
                    description=''
                    withAsterisk={false}
                />
            </ModalTakeAction>
        </React.Fragment>
    )
}

export default BarangFormCekDetilQC;